import React from 'react';
import PropTypes from 'prop-types';
import css from './StudentListStudentName.scss'
import { getWord } from 'utils/tenant';
import { SFEntityID } from 'utils/types';
import { imageStyle } from 'utils/images';

export default class StudentListStudentName extends React.Component {

  get studentFolderLink() {
    return `<a href="${this.props.getStudentFolderLink(this.props.id, this.props.studentType)}" data:card-type="${this.props.studentType}" data:card-id="${this.props.id}" class="sf-card-trigger unbound">${this.props.name}</a>`
  }

  render() {
    return (
      <div className={css['student-name-container']}>
        <div className={css['student-profile-img']}
             style={imageStyle(this.props.uuid, this.props.hasPhoto)} />
        <div className={css['student-name']}>
          <div dangerouslySetInnerHTML={{__html: this.studentFolderLink}} />
          {this.props.studentType === 'student' && <p className="student-id student">{this.props.studentId}</p>}
          {this.props.studentType === 'prospect' && <p className="student-id prospect">{getWord('prospectiveStudent')}</p>}
        </div>
      </div>
    )
  }

}

StudentListStudentName.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  id: SFEntityID.isRequired,
  hasPhoto: PropTypes.bool.isRequired,
  studentType: PropTypes.oneOf(['student', 'prospect']).isRequired,
  studentId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired
};
